var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { uniq } from 'lodash';
import { Select } from '@emburse/ui-core';
import { toTitleCase } from '@Shared/helpers/textFormatter';
import { CAPABILITIES_INTERVAL_ORDER, INTERVAL_SHORT_DISPLAY_NAMES } from '@Shared/interfaces/CardsGatewayInterfaces';
export const CapabilitiesIntervalFieldBase = (_a, ref) => {
    var { capabilities, value = '' } = _a, rest = __rest(_a, ["capabilities", "value"]);
    const intervalOptions = capabilities &&
        uniq(capabilities.allowance.interval
            .slice()
            .sort((a, b) => CAPABILITIES_INTERVAL_ORDER.indexOf(a) - CAPABILITIES_INTERVAL_ORDER.indexOf(b))
            .map((interval) => interval.toLowerCase())).map((interval) => ({
            label: toTitleCase(INTERVAL_SHORT_DISPLAY_NAMES[interval]),
            value: interval.toLowerCase()
        }));
    return (_jsx(Select, Object.assign({ native: true, required: true, fullWidth: true, label: "Frequency", name: "capabilities-interval-select", id: "capabilities-interval-select", value: value }, rest, { children: intervalOptions.map((option) => (_jsx("option", Object.assign({ value: option.value }, { children: option.label }), option.value))) })));
};
export const CapabilitiesIntervalField = React.memo(React.forwardRef(CapabilitiesIntervalFieldBase));
